// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { cn } from '@/lib/utils'

interface OnboardingProgressProps {
  currentStep: number
  totalSteps:  number
  stepLabels:  string[]
}

export function OnboardingProgress({
  currentStep,
  totalSteps,
  stepLabels,
}: OnboardingProgressProps) {
  const pct = ((currentStep - 1) / (totalSteps - 1)) * 100

  return (
    <div className="mb-7">
      {/* Step indicator */}
      <div className="flex justify-between items-center mb-2">
        <span className="text-xs text-ink-4">
          Stap {currentStep} van {totalSteps}
        </span>
        <span className="text-xs font-medium text-ink-3">
          {stepLabels[currentStep - 1]}
        </span>
      </div>

      {/* Progress track */}
      <div className="relative h-1.5 w-full rounded-full bg-sand-300 overflow-hidden">
        <div
          className="h-full rounded-full bg-moss transition-all duration-500 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>

      {/* Dot indicators */}
      <div className="flex justify-between mt-2.5 px-0.5">
        {Array.from({ length: totalSteps }).map((_, i) => {
          const step = i + 1
          const done = step < currentStep
          const active = step === currentStep
          return (
            <div
              key={step}
              className={cn(
                'h-1.5 w-1.5 rounded-full transition-all duration-300',
                done   ? 'bg-moss' :
                active ? 'bg-sage-600 scale-125' :
                         'bg-sand-300',
              )}
            />
          )
        })}
      </div>
    </div>
  )
}
